import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidatePool } from '../candidate-pool/candidate-pool.interface';
import { SlotState, SlotStateKey } from './slot-state.interface';
import slotStateService from './slot-state.service';

export interface SlotStateState {
   slot_states: Array<SlotState>;
}

const SlotStateStore: Module<SlotStateState, StoreState> = {
   namespaced: true,
   state: {
      slot_states: [],
   },

   getters: {
      getSlotStatesByKeys: (state) => (keys: Array<SlotStateKey>) => {
         return state.slot_states.filter((slotState) => keys?.find((key) => key == slotState.key));
      },
      getSlotStates(state) {
         return state.slot_states;
      },
   },

   mutations: {
      setSlotStates(state, slot_states) {
         state.slot_states = slot_states;
      },
   },

   actions: {
      async get(context, slot_state_ids: Array<number>) {
         return await slotStateService.get(slot_state_ids).then((response) => {
            if (!slot_state_ids) context.commit('setSlotStates', response.data);
            return response;
         });
      },
      async postSlotStateAllowedOrNot(context, { candidate_pools }: { candidate_pools: Array<CandidatePool> }) {
         return await slotStateService.postSlotStateAllowedOrNot(candidate_pools).then((response) => response);
      },

      async getPossibleTargets(context, { slot_ids }: { slot_ids: Array<number> }) {
         return await slotStateService.getPossibleTargets(slot_ids?.join()).then((response) => response);
      },
   },
};

export default SlotStateStore;
